import { baseUrl, headers } from 'api';

export const getDadosPessoais = async (id) => {
  const response = await fetch(`${baseUrl}/curriculo/dados/?usuario=${id}`, {
    method: 'GET',
    headers: {
      ...headers,
      Authorization: sessionStorage.getItem('@senac:token'),
    },
  });

  return response;
};
